/**
 * Permission keys, mirroring app/core/permissions.py.
 *
 * These drive useCan(), which hides or disables controls. That is a COURTESY,
 * never a control — every hidden button has a matching server-side check.
 * A hidden button is not security.
 */

export const P = {
  conversationsView: 'conversations.view',
  conversationsViewAll: 'conversations.view_all',
  conversationsReply: 'conversations.reply',
  conversationsTakeover: 'conversations.takeover',
  conversationsAssign: 'conversations.assign',
  conversationsExport: 'conversations.export',
  conversationsDelete: 'conversations.delete',

  leadsView: 'leads.view',
  leadsViewAll: 'leads.view_all',
  leadsEdit: 'leads.edit',
  leadsAssign: 'leads.assign',
  leadsMerge: 'leads.merge',
  leadsExport: 'leads.export',
  leadsDelete: 'leads.delete',

  customersView: 'customers.view',
  customersEdit: 'customers.edit',
  customersMerge: 'customers.merge',
  customersExport: 'customers.export',
  customersDelete: 'customers.delete',

  dealsView: 'deals.view',
  dealsEdit: 'deals.edit',
  dealsDelete: 'deals.delete',

  chatbotsView: 'chatbots.view',
  chatbotsManage: 'chatbots.manage',
  chatbotsPublish: 'chatbots.publish',

  knowledgeView: 'knowledge.view',
  knowledgeManage: 'knowledge.manage',

  automationsView: 'automations.view',
  automationsManage: 'automations.manage',

  integrationsView: 'integrations.view',
  integrationsManage: 'integrations.manage',

  analyticsView: 'analytics.view',
  analyticsViewTeam: 'analytics.view_team',
  analyticsExport: 'analytics.export',

  teamView: 'team.view',
  teamManage: 'team.manage',
  teamRoles: 'team.roles',

  billingView: 'billing.view',
  billingManage: 'billing.manage',

  apiKeysView: 'api_keys.view',
  apiKeysManage: 'api_keys.manage',

  settingsView: 'settings.view',
  settingsManage: 'settings.manage',
  settingsPrivacy: 'settings.privacy',
  auditView: 'audit.view',
} as const

export type Permission = (typeof P)[keyof typeof P]

/** Shown with a warning marker in the role editor. */
export const DANGEROUS: ReadonlySet<string> = new Set<string>([
  P.conversationsExport, P.conversationsDelete,
  P.leadsExport, P.leadsDelete,
  P.customersExport, P.customersDelete,
  P.dealsDelete,
  P.integrationsManage,
  P.analyticsExport,
  P.teamManage, P.teamRoles,
  P.billingManage,
  P.apiKeysManage,
  P.settingsPrivacy,
])

export const ROLE_LABELS: Record<string, string> = {
  owner: 'Owner',
  admin: 'Admin',
  manager: 'Manager',
  sales_manager: 'Sales Manager',
  sales_agent: 'Sales Agent',
  support_manager: 'Support Manager',
  support_agent: 'Support Agent',
  analyst: 'Analyst',
  developer: 'Developer',
  billing: 'Billing',
  custom: 'Custom',
}
